import logoFull from '@/assets/logo-full.png';

export default function AiChefIcon() {
  return <img src={logoFull} alt="" style={{ width: '32px', height: '32px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />;
}
